module.exports = "<div class=\"pageAbout\">\n\t<div class=\"poster\"> </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/about/about.html
// module id = 85
// module chunks = 0